import '../views/admin/assets/admincustom.css';
import { SideBar } from '../views/admin/components/sideBar'
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const MainAdmin = ({ children }) => {
    const navigate = useHistory();
    const jwt = localStorage.getItem('jwt')

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [openSideMenuMobile, setOpenSideMenuMobile] = useState({ class: 'sidebar-cls' });
    const toggleSideMenuMobile = (event) => { setOpenSideMenuMobile({ class: 'active' }); };
    const toggleSideMenuCloseMobile = (event) => { setOpenSideMenuMobile({ class: 'sidebar-cls' }); };

    const [openSideMenu, setOpenSideMenu] = useState({ class: 'sidebar-cls' });
    const toggleSideMenu = (event) => { setOpenSideMenu({ class: 'sidebar-cls' }); };
    const toggleSideMenuClose = (event) => { setOpenSideMenu({ class: 'active' }); };

    useEffect(() => {
        const verifyUser = async () => {
            if (!jwt) {
                navigate.push("/login");
            }
        };
        verifyUser();
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 768;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);

    }, [navigate, isMobile, jwt]);

    return (
        <>
            <div class="wrapper d-flex align-items-stretch admin-bg-light">
                <nav id="sidebar" class={`${isMobile ? openSideMenuMobile.class : openSideMenu.class}`}>
                    <SideBar />
                </nav>
                <div id="content" class="p-4 p-md-5">
                    <nav class="navbar navbar-expand-lg topnav-bar ">
                        {isMobile ?
                            openSideMenuMobile.class === 'sidebar-cls' ?
                                <button onClick={toggleSideMenuMobile} type="button" id="sidebarCollapse/p" class="btn btn-">
                                    <i class="fa fa-bars"></i>
                                    <span class="sr-only">Toggle Menu</span>
                                </button>
                                :
                                <button onClick={toggleSideMenuCloseMobile} type="button" id="sidebarCollapse/p" class="btn btn-">
                                    <i class="fa fa-bars"></i>
                                    <span class="sr-only">Toggle Menu</span>
                                </button>
                            :
                            openSideMenu.class === 'active' ?
                                <button onClick={toggleSideMenu} type="button" id="sidebarCollapse/p" class="btn btn-">
                                    <i class="fa fa-bars"></i>
                                    <span class="sr-only">Toggle Menu</span>
                                </button>
                                :
                                <button onClick={toggleSideMenuClose} type="button" id="sidebarCollapse/p" class="btn btn-">
                                    <i class="fa fa-bars"></i>
                                    <span class="sr-only">Toggle Menu</span>
                                </button>
                        }

                        <div class="container">
                          infocliq website admin portal
                        </div>
                    </nav>
                    {children}
                </div>
            </div>
        </>
    )
}

export default MainAdmin;

